import React, {Component} from 'react';
import sanitizeHtml from 'sanitize-html';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

import {Card} from 'semantic-ui-react';

import './Embed.css';

const htmlOptions = {
    allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        iframe: ['src', 'scrolling', 'frameborder', 'allowfullscreen']
    }
};

export default class CardEmbed extends Component {

    shouldComponentUpdate({embed}) {
        return embed !== this.props.embed;
    }

    render() {
        const {embed} = this.props,
            getHtml = () => ({
                __html: sanitizeHtml(embed, htmlOptions)
            });
        return <Card className="CardEmbed" fluid={true}>
            <LazyLoad unmountIfInvisible={true} offset={320} throttle={true}>
                <div className="CardEmbed-html" dangerouslySetInnerHTML={getHtml()}/>
            </LazyLoad>
        </Card>;
    }
}

CardEmbed.propTypes = {
    embed: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/card/Embed.js